import { ServiceData } from '@/types';

import audios from './MEDITATION_AUDIOS_EE.json';
import guides from './MEDITATION_GUIDES_EE.json';

export const MEDITATION_DATA_EE: ServiceData = {
  audios,
  guides,
};
